import angular from 'angular';

import TypeMgmt from './typeManagement.component';
import './typeManagement.component.scss';

import { downgradedModule } from '../../../ng-app/main';

export default angular
  .module('petroCloud.admin.types', [
    downgradedModule
  ])
  .component(TypeMgmt.name, TypeMgmt)
  .name;
